import { makeStyles } from '@material-ui/core';
import { Link } from '@backstage/core-components';
import AddIcon from '@material-ui/icons/Add';
import LayersIcon from '@material-ui/icons/Layers';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const ACTIONS = [
  {
    to: '/create',
    icon: <AddIcon fontSize="small" />,
    title: 'Scaffold a service',
    hint: 'Template to running repo in a few minutes',
  },
  {
    to: '/catalog',
    icon: <LayersIcon fontSize="small" />,
    title: 'Browse the catalog',
    hint: 'Owners, dependencies and APIs in one graph',
  },
  {
    to: '/docs',
    icon: <MenuBookIcon fontSize="small" />,
    title: 'Read TechDocs',
    hint: 'Docs that ship beside the code',
  },
  {
    to: '/kubernetes',
    icon: <CloudQueueIcon fontSize="small" />,
    title: 'Inspect workloads',
    hint: 'Live pod health straight from AKS',
  },
];

const useStyles = makeStyles({
  list: { display: 'grid', gap: 0 },
  row: {
    display: 'grid',
    gridTemplateColumns: 'auto minmax(0,1fr) auto',
    alignItems: 'center',
    gap: 14,
    padding: '14px 0',
    borderBottom: '1px solid var(--q-border)',
    textDecoration: 'none',
    '&:last-child': { borderBottom: 'none' },
    '&:hover $title': { color: 'var(--q-emerald-mint)' },
    '&:hover $arrow': { opacity: 1, transform: 'translateX(0)' },
  },
  icon: {
    display: 'grid',
    placeItems: 'center',
    width: 34,
    height: 34,
    borderRadius: 10,
    background: 'rgba(16,185,129,0.10)',
    border: '1px solid rgba(16,185,129,0.22)',
    color: 'var(--q-emerald)',
    flexShrink: 0,
  },
  title: {
    display: 'block',
    fontWeight: 600,
    fontSize: 14.5,
    color: 'var(--q-text)',
    transition: 'color 200ms var(--q-ease)',
  },
  hint: {
    display: 'block',
    fontSize: 12.5,
    color: 'var(--q-muted)',
    marginTop: 2,
  },
  arrow: {
    color: 'var(--q-emerald)',
    opacity: 0,
    transform: 'translateX(-6px)',
    transition: 'opacity 200ms var(--q-ease), transform 200ms var(--q-spring)',
  },
});

export const QuickActions = () => {
  const classes = useStyles();
  return (
    <div className={classes.list}>
      {ACTIONS.map(a => (
        <Link key={a.to} to={a.to} underline="none" className={classes.row}>
          <span className={classes.icon}>{a.icon}</span>
          <span>
            <span className={classes.title}>{a.title}</span>
            <span className={classes.hint}>{a.hint}</span>
          </span>
          <ArrowForwardIcon className={classes.arrow} fontSize="small" />
        </Link>
      ))}
    </div>
  );
};
